import { Injectable, Injector } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { TransferState, makeStateKey } from '@angular/platform-browser';
import 'rxjs/Rx';
import 'rxjs/add/operator/catch';
import { Router } from '@angular/router';


import * as _ from 'lodash';
import { AuthService } from "./auth.service";
import { EndpointFactory } from "./endpoint-factory.service";
import { HttpClient, HttpParams } from "@angular/common/http";
import { ConfigurationService } from "./configuration.service";
import { Benefit } from "../models/benefit.model";
import { Vendor } from "../models/vendor.model";
import { Product } from "../models/product.model";
import { Group } from "../models/group.model";
import { Paytype } from "../models/paytype.model";
import { ProductBenefit } from "../models/product-benefit.model";
import { VendorProductLookup } from "../models/vendor-product-lookup.model";
import { GroupProduct } from "../models/group-product.model";
import { BenefitType } from "../models/benefit-type.model";
import { Member } from "../models/member.model";
import { MemberAccess } from "../models/member-access.model";
import { Whitelabel } from "../models/whitelabel.model";
import { WhitelabelConfig } from "../models/whitelabel-config.model";
import { WhitelabelFeature } from "../models/whitelabel-feature.model";
import { Service } from "../models/service.model";
import { ContractTemplate } from "../models/contract-template.model";
import { Quote } from "../models/quote.model";
import { QuoteTemplate } from "../models/quote-template.model";
import { Org } from "../models/org.model";
import { Customer } from "../models/customer.model";


@Injectable()
export class ApiService extends EndpointFactory  {


    private _baseURl = "";




    constructor(http: HttpClient, configurations: ConfigurationService, injector: Injector) {
        super(http, configurations, injector);
    }


    //customer endpoints

    getCustomers(): Observable<any> {
        return this
            .http
            .get(this._baseURl + "api/customer/", this.getRequestHeaders())
            .catch(error => {
                return this.handleError(error, null);
            });


    }

    getBusinessTypes(): Observable<any> {
        return this
            .http
            .get(this._baseURl + "api/customer/business-types", this.getRequestHeaders())
            .catch(error => {
                return this.handleError(error, null);
            });


    }

    createCustomer(customer: Customer): Observable<any> {
        return this
            .http
            .post(this._baseURl + "api/customer/", customer, this.getRequestHeaders()).catch(error => {
                return this.handleError(error, null);
            });


    }

    updateCustomer(customer: Customer): Observable<any> {
        return this
            .http
            .put(this._baseURl + "api/customer/", customer, this.getRequestHeaders()).catch(error => {
                return this.handleError(error, null);
            });

    }

    deleteCustomer(customerId: number): Observable<any> {
        return this
            .http
            .delete(this._baseURl + "api/customer/" + customerId, this.getRequestHeaders()).catch(error => {
                return this.handleError(error, null);
            });


    }

    //org endpoints

    getOrgs(): Observable<any> {
        return this
            .http
            .get(this._baseURl + "api/org/", this.getRequestHeaders())
            .catch(error => {
                return this.handleError(error, null);
            });


    }

    createOrg(org: Org): Observable<any> {
        return this
            .http
            .post(this._baseURl + "api/org/", org, this.getRequestHeaders()).catch(error => {
                return this.handleError(error, null);
            });


    }

    updateOrg(org: Org): Observable<any> {
        return this
            .http
            .put(this._baseURl + "api/org/", org, this.getRequestHeaders()).catch(error => {
                return this.handleError(error, null);
            });

    }

    deleteOrg(orgId: number): Observable<any> {
        return this
            .http
            .delete(this._baseURl + "api/org/" + orgId, this.getRequestHeaders()).catch(error => {
                return this.handleError(error, null);
            });


    }

    //quote endpoints

    getQuote(quoteId): Observable<any> {
        return this
            .http
            .get(this._baseURl + "api/quote/" + quoteId, this.getRequestHeaders())
            .catch(error => {
                return this.handleError(error, null);
            });


    }

    generateDocx(qid)
        : Observable<any> {
        return this
            .http
            .get(this._baseURl + "api/quote/generate-docx/" + qid,this.getRequestHeaders())
            .catch(error => {
                return this.handleError(error, null);
            });


    }

    generateDocxContract(cid)
        : Observable<any> {
        return this
            .http
            .get(this._baseURl + "api/quote/generate-docx-contract/" + cid, this.getRequestHeaders())
            .catch(error => {
                return this.handleError(error, null);
            });


    }


    getQuotes(): Observable<any> {
        return this
            .http
            .get(this._baseURl + "api/quote/", this.getRequestHeaders())
            .catch(error => {
                return this.handleError(error, null);
            });


    }


    createQuote(quote: Quote): Observable<any> {
        return this
            .http
            .post(this._baseURl + "api/quote/", quote, this.getRequestHeaders()).catch(error => {
                return this.handleError(error, null);
            });


    }

    updateQuote(quote: Quote): Observable<any> {
        return this
            .http
            .put(this._baseURl + "api/quote/", quote, this.getRequestHeaders()).catch(error => {
                return this.handleError(error, null);
            });

    }

    //quoteTemplate endpoints

    getQuoteTemplates(): Observable<any> {
        return this
            .http
            .get(this._baseURl + "api/quoteTemplate/", this.getRequestHeaders())
            .catch(error => {
                return this.handleError(error, null);
            });


    }

    createQuoteTemplate(quoteTemplate: QuoteTemplate): Observable<any> {
        return this
            .http
            .post(this._baseURl + "api/quoteTemplate/", quoteTemplate, this.getRequestHeaders()).catch(error => {
                return this.handleError(error, null);
            });


    }

    updateQuoteTemplate(quoteTemplate: QuoteTemplate): Observable<any> {
        return this
            .http
            .put(this._baseURl + "api/quoteTemplate/", quoteTemplate, this.getRequestHeaders()).catch(error => {
                return this.handleError(error, null);
            });

    }

    deleteQuoteTemplate(quoteTemplateId: number): Observable<any> {
        return this
            .http
            .delete(this._baseURl + "api/quoteTemplate/" + quoteTemplateId, this.getRequestHeaders()).catch(error => {
                return this.handleError(error, null);
            });


    }

    //contractTemplate endpoints

    getContractTemplates(): Observable<any> {
        return this
            .http
            .get(this._baseURl + "api/contractTemplate/", this.getRequestHeaders())
            .catch(error => {
                return this.handleError(error, null);
            });


    }

    createContractTemplate(contractTemplate: ContractTemplate): Observable<any> {
        return this
            .http
            .post(this._baseURl + "api/contractTemplate/", contractTemplate, this.getRequestHeaders()).catch(error => {
                return this.handleError(error, null);
            });


    }

    updateContractTemplate(contractTemplate: ContractTemplate): Observable<any> {
        return this
            .http
            .put(this._baseURl + "api/contractTemplate/", contractTemplate, this.getRequestHeaders()).catch(error => {
                return this.handleError(error, null);
            });

    }

    deleteContractTemplate(contractTemplateId: number): Observable<any> {
        return this
            .http
            .delete(this._baseURl + "api/contractTemplate/" + contractTemplateId, this.getRequestHeaders()).catch(error => {
                return this.handleError(error, null);
            });


    }

    //services endpoints

    getServiceTypes(): Observable<any> {
        return this
            .http
            .get(this._baseURl + "api/serviceType/", this.getRequestHeaders())
            .catch(error => {
                return this.handleError(error, null);
            });


    }

    getServices(): Observable<any> {
        return this
            .http
            .get(this._baseURl + "api/service/", this.getRequestHeaders())
            .catch(error => {
                return this.handleError(error, null);
            });


    }

    createService(service: Service): Observable<any> {
        return this
            .http
            .post(this._baseURl + "api/service/", service, this.getRequestHeaders()).catch(error => {
                return this.handleError(error, null);
            });


    }

    updateService(service: Service): Observable<any> {
        return this
            .http
            .put(this._baseURl + "api/service/", service, this.getRequestHeaders()).catch(error => {
                return this.handleError(error, null);
            });

    }

    deleteService(serviceId: number): Observable<any> {
        return this
            .http
            .delete(this._baseURl + "api/service/" + serviceId, this.getRequestHeaders()).catch(error => {
                return this.handleError(error, null);
            });


    }

    //paytype endpoints

    getPaytypes(): Observable<any> {
        return this
            .http
            .get(this._baseURl + "api/paytype/", this.getRequestHeaders())
            .catch(error => {
                return this.handleError(error, null);
            });


    }

    createPaytype(paytype: Paytype): Observable<any> {
        return this
            .http
            .post(this._baseURl + "api/paytype/", paytype, this.getRequestHeaders()).catch(error => {
                return this.handleError(error, null);
            });


    }

    updatePaytype(paytype: Paytype): Observable<any> {
        return this
            .http
            .put(this._baseURl + "api/paytype/", paytype, this.getRequestHeaders()).catch(error => {
                return this.handleError(error, null);
            });

    }

    deletePaytype(paytypeId: number): Observable<any> {
        return this
            .http
            .delete(this._baseURl + "api/paytype/" + paytypeId, this.getRequestHeaders()).catch(error => {
                return this.handleError(error, null);
            });


    }

    //whitelabels enpoints

    getWhitelabelByProductId(productId): Observable<any> {
        return this
            .http
            .get(this._baseURl + "api/whitelabel/by-productId/" + productId, this.getRequestHeaders())
            .catch(error => {
                return this.handleError(error, null);
            });


    }

    getWhitelabels(): Observable<any> {
        return this
            .http
            .get(this._baseURl + "api/whitelabel/", this.getRequestHeaders())
            .catch(error => {
                return this.handleError(error, null);
            });


    }

    createWhitelabel(whitelabel: Whitelabel): Observable<any> {
        return this
            .http
            .post(this._baseURl + "api/whitelabel/", whitelabel, this.getRequestHeaders()).catch(error => {
                return this.handleError(error, null);
            });


    }

    updateWhitelabel(whitelabel: Whitelabel): Observable<any> {
        return this
            .http
            .put(this._baseURl + "api/whitelabel/", whitelabel, this.getRequestHeaders()).catch(error => {
                return this.handleError(error, null);
            });

    }

    deleteWhitelabel(whitelabelId: number): Observable<any> {
        return this
            .http
            .delete(this._baseURl + "api/whitelabel/" + whitelabelId, this.getRequestHeaders()).catch(error => {
                return this.handleError(error, null);
            });


    }

    //whitelabelConfigs enpoints

    getWhitelabelConfigs(whitelabelId: number): Observable<any> {
        return this
            .http
            .get(this._baseURl + "api/whitelabelConfig/by-whitelabelId/" + whitelabelId, this.getRequestHeaders())
            .catch(error => {
                return this.handleError(error, null);
            });


    }

    createWhitelabelConfig(whitelabelConfig: WhitelabelConfig): Observable<any> {
        return this
            .http
            .post(this._baseURl + "api/whitelabelConfig/", whitelabelConfig, this.getRequestHeaders()).catch(error => {
                return this.handleError(error, null);
            });


    }

    updateWhitelabelConfig(whitelabelConfig: WhitelabelConfig): Observable<any> {
        return this
            .http
            .put(this._baseURl + "api/whitelabelConfig/", whitelabelConfig, this.getRequestHeaders()).catch(error => {
                return this.handleError(error, null);
            });

    }

    deleteWhitelabelConfig(whitelabelId: number, whitelabelFeatureId): Observable<any> {
        return this
            .http
            .delete(this._baseURl + "api/whitelabelConfig/" + whitelabelId + "/" + whitelabelFeatureId , this.getRequestHeaders()).catch(error => {
                return this.handleError(error, null);
            });


    }

    // Gives one site its own card order, first to last. The default order from Benefit
    // Contents stops reaching that site until resetSiteOrder is called.
    saveSiteOrder(whitelabelId: number, whitelabelFeatureIds: number[]): Observable<any> {
        return this
            .http
            .put(this._baseURl + "api/whitelabelConfig/" + whitelabelId + "/order",
                 { whitelabelFeatureIds: whitelabelFeatureIds },
                 this.getRequestHeaders()).catch(error => {
                return this.handleError(error, null);
            });
    }

    resetSiteOrder(whitelabelId: number): Observable<any> {
        return this
            .http
            .delete(this._baseURl + "api/whitelabelConfig/" + whitelabelId + "/order", this.getRequestHeaders()).catch(error => {
                return this.handleError(error, null);
            });
    }

    //whitelabelfeature enpoints

    updateWhitelabelFeature(whitelabelFeature: WhitelabelFeature) {
        return this
            .http
            .put(this._baseURl + "api/whitelabelFeature/", whitelabelFeature, this.getRequestHeaders()).catch(error => {
                return this.handleError(error, null);
            });
    }

    createWhitelabelFeature(whitelabelFeature: any): Observable<any> {
        return this
            .http
            .post(this._baseURl + "api/whitelabelFeature/", whitelabelFeature, this.getRequestHeaders()).catch(error => {
                return this.handleError(error, null);
            });
    }

    // Rewrites the settings every site starts from, and carries each changed field to the
    // sites that were still showing the old default; a site with its own value keeps it.
    // Answers with { changedFields, syncedSites, keptCustom: [{ field, sites }] }.
    saveFeatureDefaults(whitelabelFeatureId: number, description: string, settings: any): Observable<any> {
        return this
            .http
            .put(this._baseURl + "api/whitelabelFeature/" + whitelabelFeatureId + "/defaults",
                 { description: description, settings: settings },
                 this.getRequestHeaders()).catch(error => {
                return this.handleError(error, null);
            });
    }

    getWhitelabelFeatures(): Observable<any>  {
        return this
            .http
            .get(this._baseURl + "api/whitelabelFeature/", this.getRequestHeaders()).catch(error => {
                return this.handleError(error, null);
            });
    }

    // Puts an icon image in blob storage under static/images and answers with { url }.
    // Saving the URL onto the benefit is a separate call, so an upload can be previewed
    // and abandoned without touching the feature's settings.
    uploadFeatureIcon(whitelabelFeatureId: number, file: any): Observable<any> {
        const fd = new FormData();
        fd.append('file', file, file.name);

        return this
            .http
            .post(this._baseURl + "api/whitelabelFeature/" + whitelabelFeatureId + "/icon-file",
                  fd,
                  this.getRequestHeadersUpload(false)).catch(error => {
                return this.handleError(error, null);
            });
    }

    // Sets the benefit's icon on the default settings and carries it to the sites still
    // showing the old one; sites given a different icon deliberately keep theirs.
    // Answers with { icon, syncedSites, keptCustomSites }.
    saveFeatureIcon(whitelabelFeatureId: number, icon: string): Observable<any> {
        return this
            .http
            .put(this._baseURl + "api/whitelabelFeature/" + whitelabelFeatureId + "/icon",
                 { icon: icon },
                 this.getRequestHeaders()).catch(error => {
                return this.handleError(error, null);
            });
    }

    // Stores the order benefits are shown in, as a sortOrder on each benefit's default
    // settings, and mirrors it onto the per-site copies. Takes the ids first to last.
    // Answers with { saved, syncedSites, unreadable }.
    saveFeatureOrder(whitelabelFeatureIds: number[]): Observable<any> {
        return this
            .http
            .put(this._baseURl + "api/whitelabelFeature/order",
                 { whitelabelFeatureIds: whitelabelFeatureIds },
                 this.getRequestHeaders()).catch(error => {
                return this.handleError(error, null);
            });
    }

    //whitelabelfeaturecontent endpoints -- Learn More copy, one body per feature,
    //shared by every whitelabel that enables that benefit.

    getLearnMoreContent(whitelabelFeatureId: number): Observable<any> {
        return this
            .http
            .get(this._baseURl + "api/whitelabelFeatureContent/" + whitelabelFeatureId, this.getRequestHeaders()).catch(error => {
                return this.handleError(error, null);
            });
    }

    saveLearnMoreContent(whitelabelFeatureId: number, learnMoreHtml: string): Observable<any> {
        return this
            .http
            .put(this._baseURl + "api/whitelabelFeatureContent/",
                 { whitelabelFeatureId: whitelabelFeatureId, learnMoreHtml: learnMoreHtml },
                 this.getRequestHeaders()).catch(error => {
                return this.handleError(error, null);
            });
    }

    deleteLearnMoreContent(whitelabelFeatureId: number): Observable<any> {
        return this
            .http
            .delete(this._baseURl + "api/whitelabelFeatureContent/" + whitelabelFeatureId, this.getRequestHeaders()).catch(error => {
                return this.handleError(error, null);
            });
    }

    //groups endpoints

    getGroups(): Observable<any> {
        return this
            .http
            .get(this._baseURl + "api/group/", this.getRequestHeaders())
            .catch(error => {
                return this.handleError(error, null);
            });


    }

    createGroup(group: Group): Observable<any> {
        return this
            .http
            .post(this._baseURl + "api/group/", group, this.getRequestHeaders()).catch(error => {
                return this.handleError(error, null);
            });


    }

    updateGroup(group: Group): Observable<any> {
        return this
            .http
            .put(this._baseURl + "api/group/", group, this.getRequestHeaders()).catch(error => {
                return this.handleError(error, null);
            });

    }

    deleteGroup(groupId: number): Observable<any> {
        return this
            .http
            .delete(this._baseURl + "api/group/" + groupId, this.getRequestHeaders()).catch(error => {
                return this.handleError(error, null);
            });


    }

    //associationFees

    getAssociationFees() {

        return this
            .http
            .get(this._baseURl + "api/associationFee/", this.getRequestHeaders()).catch(error => {
                return this.handleError(error, null);
            });
    }



    // groupProducts

    getAvailableProductsForGroup(groupId:number) {

        return this
            .http
            .get(this._baseURl + "api/groupProduct/available-products/" + groupId, this.getRequestHeaders()).catch(error => {
                return this.handleError(error, null);
            });
    }

    getExistedGroupProducts(groupId: number): Observable<any> {
        return this
            .http
            .get(this._baseURl + "api/groupProduct/" + groupId, this.getRequestHeaders()).catch(error => {
                return this.handleError(error, null);
            });


    }

    removeGroupProduct(groupProduct: GroupProduct): Observable<any> {
        return this
            .http
            .delete(this._baseURl + "api/groupProduct/remove/" + groupProduct.groupId + "/" + groupProduct.productId + "/" + groupProduct.groupProductId, this.getRequestHeaders()).catch(error => {
                return this.handleError(error, null);
            });
    }

    addGroupProduct(groupProduct: GroupProduct): Observable<any> {
        return this
            .http
            .post(this._baseURl + "api/groupProduct/add", groupProduct, this.getRequestHeaders()).catch(error => {
                return this.handleError(error, null);
            });
    }

    //products endpoints

    getProductById(id): Observable<any> {
        return this
            .http
            .get(this._baseURl + "api/product/by-id/" + id, this.getRequestHeaders())
            .catch(error => {
                return this.handleError(error, null);
            });


    }

    getProducts(): Observable<any> {
        return this
            .http
            .get(this._baseURl + "api/product/", this.getRequestHeaders())
            .catch(error => {
                return this.handleError(error, null);
            });
           
            
    }

    getProductsByGroupId(groupId): Observable<any> {
        return this
            .http
            .get(this._baseURl + "api/product/" + groupId, this.getRequestHeaders())
            .catch(error => {
                return this.handleError(error, null);
            });
    }

    createProduct(product: Product): Observable<any> {
        return this
            .http
            .post(this._baseURl + "api/product/", product, this.getRequestHeaders()).catch(error => {
                return this.handleError(error, null);
            });


    }

    updateProduct(product: Product): Observable<any> {
        return this
            .http
            .put(this._baseURl + "api/product/", product, this.getRequestHeaders()).catch(error => {
                return this.handleError(error, null);
            });

    }

    deleteProduct(productId: number): Observable<any> {
        return this
            .http
            .delete(this._baseURl + "api/product/" + productId, this.getRequestHeaders()).catch(error => {
                return this.handleError(error, null);
            });


    }

    //benefitTypes endpoints

    getBenefitTypes(): Observable<any> {
        return this
            .http
            .get(this._baseURl + "api/benefitType/", this.getRequestHeaders()).catch(error => {
                return this.handleError(error, null);
            });

    }

    createBenefitType(benefitType: BenefitType): Observable<any> {
        return this
            .http
            .post(this._baseURl + "api/benefitType/", benefitType, this.getRequestHeaders()).catch(error => {
                return this.handleError(error, null);
            });
    }

    getBenefitClassifications(): Observable<any> {
        return this
            .http
            .get(this._baseURl + "api/benefitClassification/", this.getRequestHeaders()).catch(error => {
                return this.handleError(error, null);
            });

    }

     //benefits endpoints
    getBenefits(): Observable<any> {
        return this
            .http
            .get(this._baseURl + "api/benefit/", this.getRequestHeaders()).catch(error => {
                return this.handleError(error, null);
            });


    }

    getBenefitsByProductId(productId): Observable<any> {
        return this
            .http
            .get(this._baseURl + "api/benefit/" + productId, this.getRequestHeaders()).catch(error => {
                return this.handleError(error, null);
            });


    }

    getBenefitsByExceptProductId(productId): Observable<any> {
        return this
            .http
            .get(this._baseURl + "api/benefit/get-except/" + productId, this.getRequestHeaders()).catch(error => {
                return this.handleError(error, null);
            });


    }

    getBenefitsByVendorId(vendorId): Observable<any> {
        return this
            .http
            .get(this._baseURl + "api/benefit/by-vendorId/" + vendorId, this.getRequestHeaders()).catch(error => {
                return this.handleError(error, null);
            });


    }

    createBenefit(benefit: Benefit): Observable<any> {
        return this
            .http
            .post(this._baseURl + "api/benefit/", benefit, this.getRequestHeaders()).catch(error => {
                return this.handleError(error, null);
            });


    }

    updateBenefit(benefit: Benefit): Observable<any> {
        return this
            .http
            .put(this._baseURl + "api/benefit/", benefit, this.getRequestHeaders()).catch(error => {
                return this.handleError(error, null);
            });


    }

    deleteBenefit(benefitId: number): Observable<any> {
        return this
            .http
            .delete(this._baseURl + "api/benefit/" + benefitId, this.getRequestHeaders()).catch(error => {
                return this.handleError(error, null);
            });


    }

    deleteBenefitFromProduct(benefitId: number, productId: number): Observable<any> {
        return this
            .http
            .delete(this._baseURl + "api/benefit/from-product/" + benefitId + "/" + productId, this.getRequestHeaders()).catch(error => {
                return this.handleError(error, null);
            });


    }

    //productBenefits

    createProductBenefitsBulk(productBenefits: ProductBenefit[]) {
        return this
            .http
            .post(this._baseURl + "api/productBenefit/", productBenefits, this.getRequestHeaders()).catch(error => {
                return this.handleError(error, null);
            });
    }

    //vendors enpoints

    getVendors(): Observable<any> {
        return this
            .http
            .get(this._baseURl + "api/vendor/", this.getRequestHeaders()).catch(error => {
                return this.handleError(error, null);
            });

    }

    createVendor(vendor: Vendor): Observable<any> {
        return this
            .http
            .post(this._baseURl + "api/vendor/", vendor, this.getRequestHeaders()).catch(error => {
                return this.handleError(error, null);
            });


    }

    updateVendor(vendor: Vendor): Observable<any> {
        return this
            .http
            .put(this._baseURl + "api/vendor/", vendor, this.getRequestHeaders()).catch(error => {
                return this.handleError(error, null);
            });


    }

    deleteVendor(vendorId: number): Observable<any> {
        return this
            .http
            .delete(this._baseURl + "api/vendor/" + vendorId, this.getRequestHeaders()).catch(error => {
                return this.handleError(error, null);
            });


    }

    //VendorProductLookup endpoints

    getAvailableProductsForVendor(vendorId: number): Observable<any> {
        return this
            .http
            .get(this._baseURl + "api/vendorProductLookup/available-products/" + vendorId, this.getRequestHeaders()).catch(error => {
                return this.handleError(error, null);
            });
    }

    getExistedVendorProductLookups(vendorId: number): Observable<any> {
        return this
            .http
            .get(this._baseURl + "api/vendorProductLookup/" + vendorId, this.getRequestHeaders()).catch(error => {
                return this.handleError(error, null);
            });


    }

    removeVendorProductLookup(vendorProductLookup: VendorProductLookup): Observable<any> {
        return this
            .http
            .delete(this._baseURl + "api/vendorProductLookup/remove/" + vendorProductLookup.vendorId + "/" + vendorProductLookup.productId, this.getRequestHeaders()).catch(error => {
                return this.handleError(error, null);
            });
    }

    addVendorProductLookup(vendorProductLookup: VendorProductLookup): Observable<any> {
        return this
            .http
            .post(this._baseURl + "api/vendorProductLookup/add", vendorProductLookup, this.getRequestHeaders()).catch(error => {
                return this.handleError(error, null);
            });
    }

    //member endpoints

    getMemberTypes(): Observable<any> {
        return this
            .http
            .get(this._baseURl + "api/member/member-types", this.getRequestHeaders())
            .catch(error => {
                return this.handleError(error, null);
            });


    }

    isExistingMember(memberId): Observable<any> {
        return this
            .http
            .get(this._baseURl + "api/Member/is-existing/" + memberId, this.getRequestHeaders()).catch(error => {
                console.log(error);
                return this.handleError(error, null);
            });

    }

    isExistingPolicyNumber(policyNumber): Observable<any> {
        return this
            .http
            .get(this._baseURl + "api/Member/is-existing-policy/" + policyNumber, this.getRequestHeaders()).catch(error => {
                console.log(error);
                return this.handleError(error, null);
            });


    }

    createMember(member: Member): Observable<any> {
        return this
            .http
            .post(this._baseURl + "api/Member/create-member/", member , this.getRequestHeaders()).catch(error => {
                console.log(error);
                return this.handleError(error, null);
            });


    }


    searchMembers(q, perpage): Observable<any> {
        if (!isNaN(q)) { //number
            return this
                .http
                .get(this._baseURl + `api/MemberDetails/search-by-productId?q=${q}&perpage=${perpage}`, this.getRequestHeaders()).catch(error => {
                    console.log(error);
                    return this.handleError(error, null);
                });
        } else {//string
            return this
                .http
                .get(this._baseURl + `api/MemberDetails/search?q=${q}&perpage=${perpage}`, this.getRequestHeaders()).catch(error => {
                    console.log(error);
                    return this.handleError(error, null);
                });
        }
    }

    searchMembersByModel(searchModel, perpage): Observable<any> {

            return this
                .http
                .post(this._baseURl + `api/MemberDetails/search-by-model?perpage=${perpage}`,searchModel, this.getRequestHeaders()).catch(error => {
                    console.log(error);
                    return this.handleError(error, null);
                });
        
    }

    updateMember(member: Member): Observable<any> {
        return this
            .http
            .put(this._baseURl + "api/MemberDetails", member,this.getRequestHeaders()).catch(error => {
                return this.handleError(error, null);
            });


    }

    saveMember(member: Member): Observable<any> {
        return this
            .http
            .put(this._baseURl + "api/member/update", member, this.getRequestHeaders()).catch(error => {
                return this.handleError(error, null);
            });
    }

    resetMemberLogin(memberId: number): Observable<any> {
        return this
            .http
            .get(this._baseURl + "api/member/reset-login/" + memberId, this.getRequestHeaders()).catch(error => {
                return this.handleError(error, null);
            });


    }

    getMemberDetails(start, end): Observable<any> {
        return this
            .http
            .get(this._baseURl + "api/MemberDetails?start=" + this.parseDateToTickNumber(start) + "&end=" + this.parseDateToTickNumber(end), this.getRequestHeaders()).catch(error => {
                console.log(error);
                return this.handleError(error, null);
            });


    }

    getMoreDetailMember(memberId): Observable<any> {
        return this
            .http
            .get(this._baseURl + "api/MemberDetails/more-detail/" + memberId , this.getRequestHeaders()).catch(error => {
                console.log(error);
                return this.handleError(error, null);
            });
    }

    loginAsMember(memberId): Observable<any> {
        return this
            .http
            .get(this._baseURl + "api/Account/users/login-as-member/" + memberId, this.getRequestHeaders()).catch(error => {
                console.log(error);
                return this.handleError(error, null);
            });
    }

    private parseDateToTickNumber(d) {
        if (!d) return '';
        return Date.parse(d.toString());
    }

    //member access logs

    createMemberAccess(memberAccess: MemberAccess): Observable<any> {
        return this
            .http
            .post(this._baseURl + "api/memberAccess", memberAccess, this.getRequestHeaders()).catch(error => {
                return this.handleError(error, null);
            });
    }

    getMemberAccessLastRecords(skip, take): Observable<any> {
        return this
            .http
            .get(this._baseURl + "api/memberAccess/last/" + skip + "/" + take, this.getRequestHeaders()).catch(error => {
                console.log(error);
                return this.handleError(error, null);
            });
    }

    getAllMemberAccessLastRecords(): Observable<any> {
        return this
            .http
            .get(this._baseURl + "api/memberAccess/last/" , this.getRequestHeaders()).catch(error => {
                console.log(error);
                return this.handleError(error, null);
            });
    }

    getMemberAccessByMemberId(memberId, skip, take): Observable<any> {
        return this
            .http
            .get(this._baseURl + "api/memberAccess/memberId/" + memberId + "/" + skip + "/" + take, this.getRequestHeaders()).catch(error => {
                console.log(error);
                return this.handleError(error, null);
            });
    }

    getMemberAccessPagination(page, pageSize): Observable<any> {
        return this
            .http
            .get(this._baseURl + "api/memberAccess/pagination/" + page + "/" + pageSize, this.getRequestHeaders()).catch(error => {
                console.log(error);
                return this.handleError(error, null);
            });
    }

    //Event Logs
    getEventLogsByType(logType, skip, take): Observable<any> {
        return this
            .http
            .get(this._baseURl + "api/eventLog/" + logType + "/" + skip + "/" + take , this.getRequestHeaders()).catch(error => {
                console.log(error);
                return this.handleError(error, null);
            });
    }

    addAssociates(memberId, productId): Observable<any> {
        return this.http.post(this._baseURl + '/api/associate/first-time/' + memberId + "/" + productId, {},this.getRequestHeaders()).catch(error => {
            console.log(error);
            return this.handleError(error, null);
        });
            
    }

    getSmartVaultClient(memberId): Observable<any> {
        return this.http.get(this._baseURl + '/api/smartVault/' + memberId, this.getRequestHeaders()).catch(error => {
            console.log(error);
            return this.handleError(error, null);
        });

    }

    getFoldersAndFiles(clientId) {
        return this.http.get(this._baseURl + '/api/smartVault/ff/' + clientId, this.getRequestHeaders()).catch(error => {
            console.log(error);
            return this.handleError(error, null);
        });

    }

    createCaseManagement(caseType, ccmModel) {
        console.log(ccmModel)
        return this.http.post(this._baseURl + '/api/caseManagement/create/' + caseType, ccmModel, this.getRequestHeaders()).catch(error => {
            console.log(error);
            return this.handleError(error, null);
        });

    }

    umapGetCaseDetail(caseNum) {
        return this.http.get(this._baseURl + '/api/caseManagement/get-case-detail/' + caseNum, this.getRequestHeaders()).catch(error => {
            console.log(error);
            return this.handleError(error, null);
        });
    }

    umapGetCaseDetailByMemberId(memberId) {
        return this.http.get(this._baseURl + '/api/caseManagement/get-case-detail-by-memberId/' + memberId, this.getRequestHeaders()).catch(error => {
            console.log(error);
            return this.handleError(error, null);
        });
    }

    umapSendFile(memberId, sendFileVM) {
        return this.http.post(this._baseURl + '/api/umap/send/' + memberId, sendFileVM, this.getRequestHeaders()).catch(error => {
            console.log(error);
            return this.handleError(error, null);
        });
    }

    umapGetCMNotes(caseNum): Observable<any>{
        return this.http.get(this._baseURl + '/api/umap/get-cm-notes/' + caseNum, this.getRequestHeaders()).catch(error => {
            console.log(error);
            return this.handleError(error, null);
        });
    }

    umapGetDocuments(ids): Observable<any> {
        return this.http.post(this._baseURl + '/api/umap/get-documents/',ids, this.getRequestHeaders()).catch(error => {
            console.log(error);
            return this.handleError(error, null);
        });
    }

    umapGetDocumentTemplates(): Observable<any>{
        return this.http.get(this._baseURl + '/api/umap/get-document-templates/', this.getRequestHeaders()).catch(error => {
            console.log(error);
            return this.handleError(error, null);
        });
    }

    umapSearchProviders(): Observable<any> {
        return this.http.get(this._baseURl + '/api/umap/search-providers/', this.getRequestHeaders()).catch(error => {
            console.log(error);
            return this.handleError(error, null);
        });
    }

    umapGetUnknownCases(): Observable<any> {
        return this.http.get(this._baseURl + '/api/umap/get-unknown-cases/', this.getRequestHeaders()).catch(error => {
            console.log(error);
            return this.handleError(error, null);
        });
    }

    umapGetKnownCases(): Observable<any> {
        return this.http.get(this._baseURl + '/api/umap/get-known-cases/', this.getRequestHeaders()).catch(error => {
            console.log(error);
            return this.handleError(error, null);
        });
    }

    umapAssignCase(noteId, cmNote) {
        return this.http.put(this._baseURl + '/api/umap/assign-case/' + noteId, cmNote, this.getRequestHeaders()).catch(error => {
            console.log(error);
            return this.handleError(error, null);
        });
    }


    umapSearchCases(q): Observable<any> {
        return this
            .http
            .get(this._baseURl + "api/umap/search?q=" + q, this.getRequestHeaders()).catch(error => {
                console.log(error);
                return this.handleError(error, null);
            });


    }

    umapFetchInboundDocs(): Observable<any> {
        return this
            .http
            .post(this._baseURl + "api/umap/run-web-job-sync-docs",{}, this.getRequestHeaders()).catch(error => {
                console.log(error);
                return this.handleError(error, null);
            });


    }

    uploadFilesSmartVault(clientId ,f: any) {

        //var options = this.commonService.getAuthHeader(false);
        //var blob = this.dataURItoBlob(dataURL);
        var fd = new FormData(document.forms[0]);
        fd.append(f.name, f, f.name);

        return this.http.post(this._baseURl + '/api/smartVault/upload-file/' + clientId,fd, this.getRequestHeadersUpload(false)).catch(error => {
            console.log(error);
            return this.handleError(error, null);
        });
    }

    geteFulfillment(memberId, policyNumber) {
        return this.http.get(this._baseURl + '/api/eFulfillment/' + memberId + "/" + policyNumber, this.getRequestHeaders()).catch(error => {
            console.log(error);
            return this.handleError(error, null);
        });
    }

    sendeFulfillment(memberId, policyNumber, delay1Day=true) {
        return this.http.post(this._baseURl + '/api/eFulfillment',
            {
                memberId: memberId,
                policyNumber: policyNumber,
                apiKey: "0d743b5492fb90c2cdc70b7d",
                apiSecret: "a1db57b5-7a13-48c9-b429-90133340611f",
                delay1Day: delay1Day
            },
            this.getRequestHeaders()).catch(error => {
            return this.handleError(error, null);
        });
    }

    resendEmaileFulfillment(memberId, policyNumber) {
        return this.http.post(this._baseURl + '/api/eFulfillment/resend-email/' + memberId + "/" + policyNumber, {}, this.getRequestHeaders()).catch(error => {
            console.log(error);
            return this.handleError(error, null);
        });
    }

    generatePdfeFulfillment(memberId, policyNumber) {
        return this.http.post(this._baseURl + '/api/eFulfillment/generate-pdfs/', { memberId: memberId, policyNumber: policyNumber, ApiKey: "0d743b5492fb90c2cdc70b7d", apiSecret:"a1db57b5-7a13-48c9-b429-90133340611f"}, this.getRequestHeaders()).catch(error => {
            console.log(error);
            return this.handleError(error, null);
        });
    }

    updateCareington(data):any {
        return this.http.put(this._baseURl + '/api/memberVendorLookup/update-careington/', data, this.getRequestHeaders())
    }

    //dashboard

    getInboundFilesRecent() {
        return this.http.get(this._baseURl + '/api/dashboard/inbound-files-recent', this.getRequestHeaders())
    }

    getInboundFileDetail( name, page, pageSize) {
        return this.http.get(this._baseURl + `/api/dashboard/inbound-file-detail/${name}/${page}/${pageSize}`, this.getRequestHeaders())
    }

    getInboundFileErrorDetail(name, page, pageSize) {
        return this.http.get(this._baseURl + `/api/dashboard/inbound-file-error-detail/${name}/${page}/${pageSize}`, this.getRequestHeaders())
    }

    exportInboundFileErrors(name) {
        return this.http.get(this._baseURl + `/api/dashboard/inbound-file-error-export/${name}`, { headers: this.getRequestHeaders().headers, responseType: 'blob' })
    }

    getInboundFileAddDetail(name, page, pageSize) {
        return this.http.get(this._baseURl + `/api/dashboard/inbound-file-add-detail/${name}/${page}/${pageSize}`, this.getRequestHeaders())
    }

    getLogs(memberId?: string, email?: string, page: number = 1, pageSize: number = 10): Observable<any> {
        let params = new HttpParams()
            .set('page', page.toString())
            .set('pageSize', pageSize.toString());

        if (memberId) {
            params = params.set('memberId', memberId);
        }

        if (email) {
            params = params.set('email', email);
        }

        return this.http.get<any>(this._baseURl + `/api/logs`, { params });
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/services/api.service.ts